import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class BonusJournetAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_BONUS_JOURNEY')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI(environment = 'API_BONUS_JOURNEY') {
    if (!this.api.baseURL || this.api.baseURL !== environment) this.setApi(new CoreAPI(getSessionItem(environment)));

    return this.api;
  }


  async getVerifyCampaignAccept(campaignId, federalId) {
    if (campaignId == null) {
      return false;
    }

    try {
      const { data } = await this.getAPI()
        .getInstance()
        .get(`campaign/${campaignId}/participant?brokerFederalId=${federalId}`);
      return data.length > 0;
    } catch (error) {
      return false;
    }
  }

  async postTermAccpet(campaignId) {
    if (campaignId == null) {
      return false;
    }

    const result = await this.getAPI('API_MS_BONUS_JOURNEY_BFF').getInstance().post(`send/accept/term`, { campaignId });
    return result.status === 200 || result.status === 400;
  }

  async getBonusJourneyExtractCampaign(campaignId, federalId) {
    const data = await this.getAPI()
      .getInstance()
      .get(`producttion/calculate?campaignId=${campaignId}&brokerFederalId=${federalId}`);

    return data;
  }

  async getBonusAvailable(campaignId, federalId) {
    const data = await this.getAPI()
      .getInstance()
      .get(`Producttion/avaliable-bonus?campaignId=${campaignId}&brokerFederalId=${federalId}`);
    return data;
  }
}

const api = new BonusJournetAPI();
export default api;
